import { render, staticRenderFns } from "./NavGroupObject.vue?vue&type=template&id=7847c9d8"
import script from "./NavGroupObject.vue?vue&type=script&lang=js"
export * from "./NavGroupObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports